document.addEventListener('DOMContentLoaded', function() {
    const script = document.createElement('script');
    script.src = slateVars.formURL;
    script.async = true;
    document.body.appendChild(script);

    const slateProgramFilter = strArr => {
        const selectElement = document.querySelector('#form_f8ded06e-c913-4efe-a115-27246fa6dcbb');
        const options = selectElement.querySelectorAll('option');
        
        // go through each option and hide it if it doesn't match the filter
        options.forEach(option => {
            if (option.value && !(strArr.some(str => option.innerText.toLowerCase().includes(str.toLowerCase())))) {
                option.setAttribute('hidden', true);
                option.setAttribute('disabled', true);
                if (!option.classList.contains('hidden')) {
                    option.classList.add('hidden');
                }
            }
        });

        // if there's only one option with a value, select that option
        const visibleOptions = selectElement.querySelectorAll('option:not([hidden])');
        if (visibleOptions.length == 2) {
            visibleOptions[1].selected = true;
        }

        // if there are no visible options, unhide every option we had hid
        if (visibleOptions.length == 1) {
            options.forEach(option => {
                if (option.value && !(strArr.some(str => option.innerText.toLowerCase().includes(str.toLowerCase())))) {
                    option.removeAttribute('hidden');
                    option.removeAttribute('disabled');
                    if (option.classList.contains('hidden')) {
                        option.classList.remove('hidden');
                    }
                }
            });
        }

        // check for existence of non-hidden options
    }

    // get form holder
    const formholder = document.querySelector('.wp-mu-slate-block');

    // Callback function to execute when mutations are observed
    const callback = (mutationsList, observer) => {

        // if we have the global "programStrings" variable, we can run the hider function
        if (slateVars.filters) {
            slateProgramFilter(slateVars.filters);
        } else {
            // if there's only one option with a value, select that option
            const visibleOptions = selectElement.querySelectorAll('option:not([hidden])');
            if (visibleOptions.length == 2) {
                visibleOptions[1].selected = true;
            }
        }

        observer.disconnect();
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(formholder, { childList: true });
});